module.exports = __webpack_public_path__ + "e7693cf7d8ef97c3726bddfcdd7c41e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/studio5.jpg
// module id = 185
// module chunks = 0